var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"image-and-text-box",class:{ active: _vm.isActive, inactive: !_vm.isActive },style:(_vm.customVuexStyles),on:{"click":_vm.onClick}},[_c('div',{class:[
        'image-and-text-box__image',
        { active: _vm.isActive, inactive: !_vm.isActive }
      ],style:('background-image: url(' + _vm.image + ')')}),_c('div',{staticClass:"image-and-text-box__text",class:{ active: _vm.isActive, inactive: !_vm.isActive }},[_vm._t("default")],2)])])}
var staticRenderFns = []

export { render, staticRenderFns }